import { PlusOutlined } from '@ant-design/icons';
import { ModalForm, ProFormText } from '@ant-design/pro-components';
import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import PropTypes from 'prop-types';
import { createOrganization } from '../services/organizations';

const CreateOrganizationForm = ({ reload }) => {
  const { message } = App.useApp();
  const { mutateAsync: create, isPending } = useMutation({
    mutationFn: createOrganization,
    onSuccess: () => {
      message.success('租户创建成功');
      reload?.();
    },
    onError: () => {
      message.error('租户创建失败，请重试');
    },
  });

  return (
    <ModalForm
      title="创建租户"
      trigger={
        <Button type="primary" icon={<PlusOutlined />}>
          创建租户
        </Button>
      }
      width={480}
      modalProps={{
        destroyOnHidden: true,
        okButtonProps: {
          loading: isPending,
        },
      }}
      onFinish={async (values) => {
        try {
          await create({
            data: values,
          });
          return true;
        } catch {
          return false;
        }
      }}
    >
      <ProFormText
        name="name"
        label="租户名称"
        rules={[
          {
            required: true,
            message: '请输入租户名称',
          },
        ]}
      />
      <ProFormText
        name="slug"
        label="租户标识"
        tooltip="用于展示和检索的稳定标识，真实授权仍以 Organization Id 为准"
        rules={[
          {
            required: true,
            message: '请输入租户标识',
          },
          {
            pattern: /^[a-z0-9-]+$/,
            message: '仅支持小写字母、数字和短横线',
          },
        ]}
      />
    </ModalForm>
  );
};

CreateOrganizationForm.propTypes = {
  reload: PropTypes.func,
};

export default CreateOrganizationForm;
